<template>
  <div>
    <FormWizardStepHeader
      title="Select the startup stages you invest in"
      description="Let startups know in which stage you invest in so you’ll get the right match"
    >
      <TipToggle title="Stages explained" class="mt-20">
        <p>
          <b>Idea</b><br />
          The business idea is validated and a prototype is in the making or
          ready to be launched.
        </p>
        <br />
        <p>
          <b>Prototype or product</b><br />
          The validated prototype/product is launched with beta or real users.
        </p>
        <br />
        <p>
          <b>Go-to-market</b><br />
          The validated product is launched with paying (retaining) customers.
        </p>
        <br />
        <p>
          <b>Growth & expansion</b><br />
          The product is growing with paying retaining customers, proven
          scalability and unit economics.
        </p>
      </TipToggle>
    </FormWizardStepHeader>

    <AlertSlideUpDown :show="$v.stages.$error"
      >Please select a stage</AlertSlideUpDown
    >

    <FormItem required>
      <b-form-checkbox-group
        v-model="form.stages"
        buttons
        class="btn-group-outline-spaced-big mb-20"
        @input="$v.stages.$touch()"
      >
        <b-form-checkbox
          v-for="stage in stages"
          :key="stage.value"
          :value="stage.value"
          >{{ stage.label }}</b-form-checkbox
        >
      </b-form-checkbox-group>
    </FormItem>
  </div>
</template>

<script>
import FormItem from '@/components/form/FormItem'
import TipToggle from '@/components/TipToggle'
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import AlertSlideUpDown from '@/components/AlertSlideUpDown'

export default {
  name: 'CompanyFormStepStage',
  components: {
    AlertSlideUpDown,
    FormWizardStepHeader,
    TipToggle,
    FormItem
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      }
    }
  },
  computed: {
    stages() {
      return this.$store.getters['meta/companyStages']
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  }
}
</script>
